// Setup globali: importati PRIMA di App per inizializzare lib (firebase compat,
// dayjs plugin + locale it) e quindi disponibili a tutti i moduli a valle.
import './lib/firebase';
import './lib/dayjs';

// Font Awesome 6 (CSS only, classnames `fa-solid fa-*` usate in tutta l'app).
// Servito via bundler invece che da CDN.
import '@fortawesome/fontawesome-free/css/all.min.css';

// AdminLTE 3 (template base + Bootstrap 4 incluso). Migrato da
// `public/dist/css/adminlte.min.css` a npm in modo che Vite lo bundle e versioni.
import 'admin-lte/dist/css/adminlte.min.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import App from './app/App';
import { initMessaging } from './lib/messaging';
import { AppConfirmProvider, CancelReasonProvider, Toast } from '@ui';
import store from './store';
import './app/styles/tokens.css';
import './app/styles/forms.css';
import './index.css';

// Clean up expired localStorage cache entries on startup
try {
  const TTL_MAP = {
    'distanceCache:': 6 * 60 * 60 * 1000,
    'osrm:': 24 * 60 * 60 * 1000,
    // Unsaved process (workflow) drafts, see shared/ui/process/useStoredDraft.
    'process-draft:': 30 * 24 * 60 * 60 * 1000,
  };
  const toRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;
    const prefix = Object.keys(TTL_MAP).find((p) => key.startsWith(p));
    if (prefix) {
      try {
        const { ts } = JSON.parse(localStorage.getItem(key));
        if (Date.now() - ts > TTL_MAP[prefix]) toRemove.push(key);
      } catch {
        toRemove.push(key);
      }
    }
  }
  toRemove.forEach((k) => localStorage.removeItem(k));
} catch {}

if (import.meta.env.VITE_ENV == 'dev') {
  window.firebase.auth().useEmulator('http://localhost:9099');
  window.firebase.firestore().useEmulator('localhost', 8080);
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <AppConfirmProvider>
        <CancelReasonProvider>
          <Router>
            <App />
          </Router>
        </CancelReasonProvider>
      </AppConfirmProvider>
      <Toast />
    </LocalizationProvider>
  </Provider>
);

initMessaging();
